import Vue from 'vue';

import router from '@/services/router';
import store from '@/services/store';

import VuePlugin from '@/plugins/VuePlugin';
import VueObserveVisibility from 'vue-observe-visibility';
import VueGtag from "vue-gtag";

import App from '@/App.vue';

import VueApollo from 'vue-apollo';
import apolloClient from '@/services/api';

Vue.config.productionTip = true;
Vue.config.devtools = true;

Vue.use(VueApollo);
Vue.use(VuePlugin);
Vue.use(VueObserveVisibility);
Vue.use(VueGtag, {
  config: {
    id: "UA-206384156-1",
    params: {
      anonymize_ip: true
    },
  },
  appName: 'profunda Website',
  pageTrackerScreenviewEnabled: true,
  bootstrap: false,
}, router);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

new Vue({
  render: h => h(App),
  store,
  router,
  apolloProvider,
}).$mount('#app');
